/*
 * CUSTOM (Schuhbeck): collapsible collection description
 * Companion to sections/main-collection-banner.liquid.
 * Clamps the description to its first line and reveals a show-more toggle
 * only when the text overflows; without JS the description renders in full.
 */

if ( typeof CollapsibleDescription !== 'function' ) {

	class CollapsibleDescription extends HTMLElement {

		connectedCallback(){

			this._text = this.querySelector('.collection-description__text');
			this._toggle = this.querySelector('.collection-description__toggle');
			if ( ! this._text || ! this._toggle ) return;

			this._label = this._toggle.querySelector('.collection-description__toggle-label');

			this.classList.add('is-collapsed');
			this._evaluate();

			this._toggle.addEventListener('click', ()=>{
				const expand = this.classList.contains('is-collapsed');
				this.classList.toggle('is-collapsed', ! expand);
				this._toggle.setAttribute('aria-expanded', expand ? 'true' : 'false');
				this._label.textContent = expand ? this._toggle.dataset.labelLess : this._toggle.dataset.labelMore;
			});

			this._onResize = ()=>{
				window.requestAnimationFrame(()=>this._evaluate());
			};
			window.addEventListener('resize', this._onResize);

			// web fonts can change line wrapping after the first measurement
			if ( document.fonts && document.fonts.ready ) {
				document.fonts.ready.then(()=>this._evaluate());
			}

		}

		disconnectedCallback(){
			window.removeEventListener('resize', this._onResize);
		}

		// while collapsed, show the toggle only if the clamped text overflows
		_evaluate(){
			if ( ! this.classList.contains('is-collapsed') ) return;
			this._toggle.hidden = this._text.scrollHeight <= this._text.clientHeight + 1;
		}

	}

	customElements.define('collapsible-description', CollapsibleDescription);

}
